import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./farmFilter.data.form";
import {
  InputDate,
  InputText,
  InputSelect,
  InputCheck,
  InputAutoComplete,
} from "@de-prado-dev/react-component-library";

import {} from "../../../../constants";
import {
  FilterAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionButton,
  AccordionCollapse,
  AccordionBody,
  FilterForm,
  FilterRow,
  FilterCol,
  FilterActions,
  FilterButtonPrimary,
  FilterButtonSecondary,
} from "../../session/sessionListNew/sessionListNew.styled";

const FarmFilterForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onClean, transportCompanies, onFilterOwner } = props;

  const renderListOwner = (item) => {
    return `${item.completeName}`;
  };

  return (
    <>
      <FilterAccordion>
        <AccordionItem>
          <AccordionHeader>
            <AccordionButton
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCollapse"
              aria-expanded="false"
              aria-controls="filterCollapse"
            >
              <i className="fas fa-filter"></i>
              {t("forms.center.filter")}
            </AccordionButton>
          </AccordionHeader>
          <AccordionCollapse
            id="filterCollapse"
            className="accordion-collapse collapse"
          >
            <AccordionBody>
              <FilterForm onSubmit={handleSubmit} autoComplete="off">
                <FilterRow>
                  <FilterCol>
                    <Field
                      id="name"
                      className="form-control"
                      labelField={t("forms.center.labels.name")}
                      name="name"
                      placeholder=""
                      component={InputText}
                      fieldType="text"
                    />
                  </FilterCol>
                </FilterRow>

                <FilterActions>
                  <FilterButtonPrimary type="submit">
                    <i className="fas fa-search"></i>
                    {t("search") || "Buscar"}
                  </FilterButtonPrimary>
                  <FilterButtonSecondary
                    type="button"
                    onClick={() => onClean(props.resetForm)}
                  >
                    <i className="fas fa-trash"></i>
                    {t("forms.cleanFilter")}
                  </FilterButtonSecondary>
                </FilterActions>
              </FilterForm>
            </AccordionBody>
          </AccordionCollapse>
        </AccordionItem>
      </FilterAccordion>
    </>
  );
};

FarmFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const FarmFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "FarmFilterForm",
})(FarmFilterForm);

export default FarmFilterFormF;
